import {observable, action, computed, } from 'mobx';

import { api } from '../../services';

class CatalogStore {
  @observable
  products = [];
  @observable
  inProgress = false;

  @action
  loadProducts(profile) {
    this.setInProgress(true);
    return api({ action: 'get catalog' })
      .then(catalog => {

        this.products = catalog.services;

        if (profile) {
          if (profile.durations && profile.durations.length > 0) {

            this.products = this.products.map(product => {
              product.productRatePlans = product.productRatePlans.filter(ratePlan => profile.durations.includes(parseInt(ratePlan.duration, 10)));
              return product;
            })
          }

          if (profile.subscriptionTypes && profile.subscriptionTypes.length > 0) {

            const allowedSubscriptionTypes = profile.subscriptionTypes.map(subscriptionType => subscriptionType.name);

            this.products = this.products.map(product => {
              product.productRatePlans = product.productRatePlans.filter(ratePlan => !!ratePlan.chargeModel && allowedSubscriptionTypes.includes(ratePlan.chargeModel));
              return product;
            })
          }

          this.products = this.products.filter(product => product.productRatePlans && product.productRatePlans.length > 0);

          if (profile.channel) {

            this.products = this.products.filter(s => profile.channel.includes(s.id));
          }
      }
        return { products: this.products };
      })
      .catch(error => {
        return { error };
      })
      .then(({ error }) => {
        this.setInProgress(false);
        if (error) {
          return Promise.reject(error);
        }
      });
  }

  @action
  setInProgress(inProgress) {
    this.inProgress = inProgress;
  }

  @computed
  get oneTimes() {
    let oneTimes = [];
    //productWithOneTime
    this.products.forEach(product => {
      product.productRatePlans.forEach(plan => {
        oneTimes.push(Object.assign({}, plan, { productId: product.id, productName: product.name, skipInvoice: product.skipInvoice }));
      });
    });
    return oneTimes;
  }

  @computed
  get recurringsGroupByOneTime() {
    let result = {};
    this.oneTimes.forEach(o => {
      result[o.id] = this.recurrings.find(r => r.risk === o.risk && r.productId === o.productId && r.service_level === o.service_level);
    });
    return result;
  }
}

export default new CatalogStore();



// WEBPACK FOOTER //
// ./src/stores/catalogStore/index.js